import React, { FunctionComponent, memo, useContext } from 'react'
import { MimeType } from '@helpers/pixelate'
import { musicContext } from '@hoc/WithMusic'
import { usePixelateImage } from '@hooks/usePixelate'
import { useTranslation } from 'react-i18next'
import defaultMusicInput from './no-album.jpg'
import defaultMusicInputAvif from './no-album.avif'
import defaultMusicInputWebp from './no-album.webp'
import Image from '@components/Image/Image'
import './AlbumImage.scss'

const AlbumImage: FunctionComponent = () => {
  const { t } = useTranslation('Music')
  const { selectedAlbum } = useContext(musicContext)

  const pixelatedAlbum = usePixelateImage(selectedAlbum?.artworkUrl, MimeType.JPEG)

  if (!selectedAlbum) {
    return <div className="placeholder">{t('noAlbumToDisplay')}</div>
  }

  if (!pixelatedAlbum) {
    return (<div className="AlbumImage">
      <Image src={defaultMusicInput} srcWebp={defaultMusicInputWebp} srcAvif={defaultMusicInputAvif} />
    </div>)
  }

  return (<div className="AlbumImage">
    <Image src={pixelatedAlbum} />
  </div>)
}

export default memo(AlbumImage)
